/**
 * Global Application Constants
 *
 * All literal strings should be defined here or in specific constant files (e.g. routes.ts)
 * to ensure consistency and reusability.
 */

export const APP = {
    NAME: 'MEMORAI',
    DESCRIPTION: 'Capture your thoughts instantly.',
} as const;
